import type { Data as JobData } from '../../pages/job/@jobId/@seoSlug/+data';

/**
 * Reads `#job-initial` JSON (SSR + hydration) synchronously so the first client paint
 * can match server HTML — avoids an empty shell before `useEffect` runs.
 */
export function parseJobInitialScriptFromDocument(doc: Document | null | undefined): JobData | null {
  if (!doc) return null;
  try {
    const scriptEl = doc.getElementById('job-initial');
    if (!scriptEl || scriptEl.tagName !== 'SCRIPT') return null;
    const raw = (scriptEl as HTMLScriptElement).textContent ?? '';
    const parsed = JSON.parse(raw) as { data?: JobData } | JobData | null;
    if (!parsed || typeof parsed !== 'object') return null;
    const parsedData =
      'data' in parsed ? (parsed as { data?: JobData }).data ?? null : (parsed as JobData | null);
    if (!parsedData?.job) return null;
    return parsedData;
  } catch {
    return null;
  }
}
